import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import $api from "./openapi";
import { components } from "../ApiSchema";
import toast from "react-hot-toast";

export default function useUpdatePart() {
  const { teamSlug, partId: defaultPartId } = useParams();
  const queryClient = useQueryClient();

  const { mutate, isPending } = $api.useMutation(
    "patch",
    "/api/teams/{team_slug}/requested_parts/{id}",
    {
      // making this async will ensure `onSuccess` from updatePart is called after
      // all queries are invalidated and will prevent value changes
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/requested_parts/{id}"],
        });
        await queryClient.invalidateQueries({
          queryKey: [
            "get",
            "/api/teams/{team_slug}/quote_revisions/{id}/line_items",
          ],
        });
        await queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/full"],
        });
        await queryClient.invalidateQueries({
          queryKey: [
            "get",
            "/api/teams/{team_slug}/requested_parts/find_with_operations",
          ],
        });
      },
      onError: ({ detail }) =>
        toast.error(detail, {
          className: "whitespace-pre-wrap",
        }),
    },
  );

  return {
    updatePart: ({
      payload,
      partId = defaultPartId!,
      onSuccess = () => {},
    }: {
      payload: components["schemas"]["RequestedPartCreateSchemaPatch"];
      partId?: string;
      onSuccess?: () => void;
    }) =>
      mutate(
        {
          params: {
            path: { team_slug: teamSlug!, id: partId },
          },
          body: payload,
        },
        {
          onSuccess,
        },
      ),
    isPending,
  };
}
